import * as React from 'react';

import CloudinaryImage from 'components/CloudinaryImage';
import ActionButton from 'components/buttons/action-button/ActionButton';
import ActionLink from 'components/buttons/action-link/ActionLink';

import { __t, applyTranslations } from 'utils/language';

import type { SharedAccessOutfitCreator, SharedAccessOutfitsState } from '../../types/shared-access-outfits.type';

import './shared-outfits-header.scss';

applyTranslations(require('./shared-outfits-header.i18n.json'));

type Props = {
  influencer: SharedAccessOutfitCreator,
  totalItems: number,
  totalOutfits: number,
  currentState: SharedAccessOutfitsState,
  onDownload: () => void,
  onSave: () => void,
  addOutfit: () => void
};

const SharedOutfitsHeader = (
  {
    influencer,
    currentState,
    totalItems,
    totalOutfits,
    onDownload,
    onSave,
    addOutfit
  }: Props
): JSX.Element => {
  const isSaveDisabled = currentState !== 'dirty';
  const isDownloadDisabled = currentState === 'dirty';

  const fullName = `${influencer.firstName} ${influencer.lastName}`;

  return (
    <section className="shared-outfits-header">
      <div className="shared-outfits-header__content">
        <div className="shared-outfits-header__creator">
          <div className="shared-outfits-header__creator-picture">
            <CloudinaryImage
              image={influencer.profileImage}
              width={56}
              height={56}
            />
          </div>
          <div className="shared-outfits-header__creator-name">
            <div className="shared-outfits-header__creator-account-name">
              {influencer.artistName}
            </div>
            {fullName && fullName !== influencer.artistName && (
              <div className="shared-outfits-header__creator-full-name">
                ({fullName})
              </div>
            )}
          </div>
        </div>

        <div className="shared-outfits-header__stats">
          <div className="shared-outfits-header__stat-entry">
            {__t('shared_outfits_header.total_outfits_label')} {totalOutfits}
          </div>
          <div className="shared-outfits-header__stat-entry">
            {__t('shared_outfits_header.total_items_label')} {totalItems}
          </div>
        </div>
        {
          !isDownloadDisabled && (totalOutfits > 0) && (
            <ActionLink
              className="shared-outfits-header__download-outfit"
              color="secondary"
              size="normal"
              onClick={onDownload}
            >
              {__t('shared_outfits_header.download_outfits_label')}
            </ActionLink>
          )
        }
        <ActionButton
          onClick={addOutfit}
        >
          {__t('shared_outfits_header.add_outfits_label')}
        </ActionButton>
        <ActionButton
          color="primary"
          disabled={isSaveDisabled}
          onClick={onSave}
        >
          {
            __t(`shared_outfits_header.save_outfits_labels.${currentState}`)
            || __t('shared_outfits_header.save_outfits_labels.default')
          }
        </ActionButton>
      </div>
    </section>
  );
};

export default SharedOutfitsHeader;
